var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"allow":"autoplay"}},[_c('video-player',{attrs:{"videoId":_vm.videoId,"permalink":_vm.permalink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }